<template>
  <!--::banner topo::-->
  <section v-if="bannerTopo != ''" class="breadcrumb">
    <div class="img-avance">
      <img :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem" class="bg-img-fill" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="breadcrumb_iner">
            <div class="breadcrumb_iner_item">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--::info 1::-->
  <section v-if="listaServicos != ''" class="garantia-section">
    <div class="garantia-container">
      <div class="garantia-row">
        <div class="garantia-col-img hidden-sm hidden-xs">
          <img :src="$imgURL + listaServicos.insInstitucionalImagens[0].itgUrlImagem" :alt="listaServicos.itiNome"
            class="garantia-img">
        </div>

        <div class="garantia-col-content">
          <div class="garantia-text-wrapper">
            <h2 class="garantia-title">{{ listaServicos.itiNome }}</h2>
            <p v-html="listaServicos.itiResumo1"></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--::info 2::-->
  <section v-if="listaServicos != ''" class="garantia-section">
    <div class="garantia-container-2">
      <div class="garantia-row d-flex flex-column-reverse flex-md-row">
        <div class="garantia-col-content">
          <div class="garantia-text-wrapper">
            <h2 class="garantia-title">{{ listaServicos.itiReferencia }}</h2>
            <p v-html="listaServicos.itiResumo2"></p>
          </div>
        </div>
        <div class="garantia-col-img">
          <img :src="$imgURL + listaServicos.insInstitucionalImagens[1].itgUrlImagem" alt="" class="garantia-img">
        </div>
      </div>
    </div>
  </section>

  <!--::planos::-->
  <section v-if="listaPlanos.length > 0" class="planos_part">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="section_tittle">
            <h1>Nossos Planos</h1>
          </div>
        </div>
      </div>
      <div class="row">
        <div
          v-for="planos in listaPlanos[0].insInstitucionalGrids.filter(item => item.insListaGaleriaInstGrids?.lgtId === 5)"
          :key="planos.igsId" class="col-lg-4 col-md-6 mb-4">
          <div class="planos_card">
            <div>
              <h3>{{ planos.igsNome }}</h3>
              <ul class="planos_list">
                <li v-html="planos.igsResumo"></li>
              </ul>
            </div>
            <router-link :to="'/contato'" class="btn_planos">ASSINE JÁ</router-link>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--=============== call to action ====================-->
  <PageCallAction></PageCallAction>

</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';
import { useRoute } from 'vue-router';
import PageCallAction from '@/components/PageCallAction.vue';

export default {
  name: 'ProdutosDetalheView',

  components: {
    PageCallAction,
  },

  setup() {
    const route = useRoute();
    const id = route.params.id;
    const nome = route.params.nome;
    return {
      id,
      nome
    };
  },

  data: () => ({
    listaServicos: [],
    bannerTopo: [],
    listaPlanos: [],
  }),

  methods: {
    toggleItem(id) {
      // Se clicar no que já está aberto, ele fecha. Se não, abre o novo.
      this.itemAberto = this.itemAberto === id ? null : id;
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Garante Max :: ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Avance Digital" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // BANNER TOPO
    axios.get('/Process/InsInstitucional/institucional/59/topoprodutos/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML, this.bannerTopo[0].itiNome);
        //console.log('bannerTopo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // LISTA DE SERVIÇOS
    axios.get('/Process/InsInstitucional/GetById/' + this.id)
      .then(response => {
        this.listaServicos = response.data;
        console.log('listaServicos')
        console.log(this.listaServicos)
      })
      .catch(error => {
        console.error(error);
      });

    // PLANOS
    axios.get('/Process/InsInstitucional/institucional/46/listadeprodutos/0/x')
      .then(response => {
        this.listaPlanos = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const valorA = parseInt(a.itiOrdem) || 0;
          const valorB = parseInt(b.itiOrdem) || 0;
          return valorA - valorB;
        });
        //console.log('listaPlanos')
        //console.log(this.listaPlanos)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>